import { Page } from "@/models/page-models/Page";

export const GroupSalesComparison: Page = {
  "path": "group-sales-comparison",
  "name": "Group Sales Comparison",
  "props": {
    "data": {
      "title": "Group Sales Comparison",
      "printable": "FALSE",
      "url": "group-sales-comparison",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToGroupSalesComparison",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/group-sales-comparison",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"year\":\"{{formData.year}}\"}"
                      },
                      "name": "redirectToGroupSalesComparison"
                    }
                  ]
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesComparison",
                  "showIf": "{{fetchedData.comparisonData.data}}",
                  "comparisonDataVariable": "fetchedData.comparisonData.data",
                  "mode": "customer"
                }
              ],
              "showIf": "{{fetchedData.comparisonData.data}}",
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.comparisonData.data.status}},'),==,'Approved')"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultGroupComparisonForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultGroupComparisonForm",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultGroupComparisonForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "loadSalesComparisonData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-forecast/group-sales-comparison",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.comparisonData",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "loadSalesComparisonData"
      }
    ],
    "functions": [
      {
        "name": "getDefaultGroupComparisonForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}